/* @flow */
// typecheck: ignore file
import Box from 'components/Box.jsx';
import BoxButton from 'components/BoxButton.jsx';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import LinkConstants from 'constants/LinkConstants';
import MediaObject from 'components/MediaObject.jsx';
import Image from 'components/Image.jsx';
import openApp from 'utils/openApp';
import React from 'react';
import Text from 'components/Text.jsx';
import TitleHeader from 'components/TitleHeader.jsx';
import UserAgent from 'lib/UserAgent';
import View from 'components/View.jsx';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import './styles/AppUpsellPage.scss';

type Props = {
  group: ?Group,
  origin: ?string,
  haveAppUrl: ?string,
  isAdmin: boolean,
  hasAdminConsoleAccess: boolean,
};

const RatingGlyph = () =>
  <Glyph name="star" color="tuscan" size="xxsmall" className="AppUpsellPage-appStore-ratingGlyphs-item" />;

class AppUpsellPage extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  alreadyHaveApplication = () => {
    openApp(this.props.haveAppUrl);
  }

  render() {
    const { origin, group, isAdmin, hasAdminConsoleAccess } = this.props;
    const userAgent = new UserAgent(window.navigator.userAgent);
    let title = 'Get the Remind app';
    let storeLink = LinkConstants.APP_DOWNLOAD;

    if (origin === 'group_created' && group) {
      title = `${group.getName()} is ready!`;
    } else if (origin === 'subscribed' && group) {
      title = `Go to ${group.getName()}!`;
    }

    if (userAgent.ios()) {
      storeLink = LinkConstants.APP_STORE;
    } else if (userAgent.android()) {
      storeLink = LinkConstants.GOOGLE_PLAY;
    }

    return (
      <View className="AppUpsellPage">
        <div className="AppUpsellPage-inner">
          <Container size="xsmall">
            <header className="AppUpsellPage-header">
              <Container>
                <TitleHeader
                  title={title}
                  subtext="Send and receive messages instantly on your phone."
                  size="xlarge"
                />
                <Box className="AppUpsellPage-box" full>
                  <div className="AppUpsellPage-box-body">
                    <a href={storeLink}>
                      <MediaObject gutter="small">
                        <div className="AppUpsellPage-box-body-icon AppUpsellPage-box-body-icon--brand">
                          <Glyph name="remind-icon" color="white" size="xxlarge" />
                        </div>
                        <div>
                          <h3 className="AppUpsellPage-box-body-title">Remind</h3>
                          <div className="AppUpsellPage-box-body-ratingGlyphs">
                            <RatingGlyph />
                            <RatingGlyph />
                            <RatingGlyph />
                            <RatingGlyph />
                            <RatingGlyph />
                          </div>
                          <Text
                            color="eclipse"
                            element="div"
                            size="xxxsmall"
                            className="AppUpsellPage-box-body-info">
                            30,000+ 5-star reviews
                          </Text>
                        </div>
                      </MediaObject>
                    </a>
                  </div>
                  <BoxButton href={storeLink} text="Download Remind app" />
                </Box>
              </Container>
              {isAdmin && hasAdminConsoleAccess &&
                <Container>
                  <Box className="AppUpsellPage-box" full>
                    <div className="AppUpsellPage-box-body">
                      <MediaObject gutter="small">
                        <div className="AppUpsellPage-box-body-icon AppUpsellPage-box-body-icon--admin">
                          <Image src={require('assets/images/admin/infographics.svg')} />
                        </div>
                        <div>
                          <h3 className="AppUpsellPage-box-body-title">Admin Console</h3>
                          <Text
                            color="eclipse"
                            element="div"
                            size="xxxsmall"
                            className="AppUpsellPage-box-body-info">
                            View school and teacher statistics, browse
                            classes, manage people and much more from Remind‘s
                            administrator console.
                          </Text>
                        </div>
                      </MediaObject>
                    </div>
                    <BoxButton disabled color="thunder" text="Log in from your computer" />
                  </Box>
                </Container>
              }
            </header>
            {this.props.haveAppUrl && origin === 'direct' &&
              <Button
                color="brand"
                level="text"
                weight="semibold"
                eventElementName="openAppButton"
                onClick={this.alreadyHaveApplication}
                full>
                I already have the app
              </Button>
            }
          </Container>
        </div>
      </View>
    );
  }
}


const withAdminOrganizations = graphql(gql`
  query {
    me {
      id
      featureFlags {
        web_admin_console
      }
      potential_admin_organizations: organizations(affiliation_status: [admin, pending_admin]) {
        id
      }
      pending_organizations: organizations(first: 1, affiliation_status: [pending_admin]) {
        id
      }
    }
  }`, {
    props: ({ data }) => ({
      isAdmin: data.me ? data.me.potential_admin_organizations.length > 0 : false,
      hasAdminConsoleAccess: data.me ? data.me.featureFlags['web_admin_console'] : false,
    }),
  }
);

export { AppUpsellPage };
export default withAdminOrganizations(AppUpsellPage);



// WEBPACK FOOTER //
// ./src/user/components/AppUpsellPage.jsx